'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MastheadExtensionBasicView = require('../MastheadExtensionBasicView');

var _MastheadExtensionBasicView2 = _interopRequireDefault(_MastheadExtensionBasicView);

var _MastheadExtensionSectionView = require('../MastheadExtensionSectionView');

var _MastheadExtensionSectionView2 = _interopRequireDefault(_MastheadExtensionSectionView);

var _props = require('../props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSectionObject = function getSectionObject(section, sectionName) {
    return section && !section.hideMastheadExtension ? section : (0, _extends3.default)({}, section, {
        name: sectionName
    });
}; /* eslint-disable import/no-named-as-default */


var MastheadExtension = function MastheadExtension(_ref) {
    var theme = _ref.theme,
        mastheadExtension = _ref.mastheadExtension,
        importantSections = _ref.importantSections,
        sectionsMenu = _ref.sectionsMenu,
        sectionPath = _ref.sectionPath,
        sectionName = _ref.sectionName,
        isDropdownOpen = _ref.isDropdownOpen,
        attributes = _ref.attributes,
        engagement = _ref.engagement;

    var sections = sectionsMenu.filter(function (s) {
        return s.path && new RegExp(s.path).test(sectionPath);
    });
    var mastheadExtensionSection = sections && sections[0];
    var section = getSectionObject(mastheadExtensionSection, sectionName);
    var mastheadClass = isDropdownOpen ? theme['mastheadExtension-isOpen'] : theme.mastheadExtension;

    return _react2.default.createElement(
        'div',
        { className: mastheadClass, role: 'navigation', 'aria-label': 'submenu' },
        _react2.default.createElement(
            'div',
            { className: theme.innerContainer },
            section.name ? _react2.default.createElement(_MastheadExtensionSectionView2.default, {
                section: section,
                theme: theme,
                mastheadExtension: mastheadExtension,
                isDropdownOpen: isDropdownOpen,
                attributes: attributes,
                engagement: engagement,
                sectionPath: sectionPath
            }) : _react2.default.createElement(_MastheadExtensionBasicView2.default, {
                theme: theme,
                importantSections: importantSections,
                mastheadExtension: mastheadExtension,
                attributes: attributes,
                engagement: engagement,
                sectionPath: sectionPath
            })
        )
    );
};

if (process.env.NODE_ENV !== 'production') {
    MastheadExtension.propTypes = {
        attributes: _propTypes2.default.func,
        engagement: _propTypes2.default.func,
        isDropdownOpen: _propTypes2.default.bool,
        mastheadExtension: _propTypes2.default.shape(_props.mastheadExtensionProps).isRequired,
        importantSections: _propTypes2.default.arrayOf(_propTypes2.default.shape(_props.sectionProps)).isRequired,
        sectionsMenu: _propTypes2.default.arrayOf(_propTypes2.default.shape(_props.sectionMenuObjectProps)).isRequired,
        sectionPath: _propTypes2.default.string,
        sectionName: _propTypes2.default.string,
        theme: _propTypes2.default.shape({
            mastheadExtension: _propTypes2.default.string,
            innerContainer: _propTypes2.default.string
        })
    };
}

MastheadExtension.defaultProps = {
    attributes: function attributes() {},
    engagement: function engagement() {
        return _promise2.default.resolve();
    },
    isDropdownOpen: false,
    sectionName: undefined,
    sectionPath: undefined,
    theme: {}
};

exports.default = MastheadExtension;
//# sourceMappingURL=MastheadExtension.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/MastheadExtension/MastheadExtension.js
 ** module id = 605
 ** module chunks = 1
 **/